module.exports = __webpack_public_path__ + "img/yctiwy-3.5b691dda.jpg";